import { VenueReservation } from "@/graphql/operations";
import icons from "@/tools/icons";
import Stack from "@mui/material/Stack";

type GuestsAndGuidesSummaryProps = {
  reservation: VenueReservation;
};
export default function GuestsAndGuidesSummary({
  reservation,
}: GuestsAndGuidesSummaryProps) {
  return (
    <Stack
      direction="row"
      gap={1}
      justifyContent="flex-end"
      sx={{ width: "42px" }}
      data-testid="guests-and-guides-summary"
    >
      <Stack direction="column">
        <Stack direction="row" alignItems="center" justifyContent="end">
          {reservation.numGuests || "?"}

          <icons.Person />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="end">
          {reservation.numGuides || "?"}

          <icons.Flag sx={{ position: "relative" }} />
        </Stack>
      </Stack>
    </Stack>
  );
}
